import { CommonFragments } from './common.fragments';

export class SectorDiversificationFragments {
  /*
   * GraphQL Fragment for the Sector Diversification Exhibit
   */
  public static readonly sectorDiversificationFragment = `
    metadata {
      category
    }
    historicalSectorDiversificationExhibit {
      equity {
        ${CommonFragments.disclaimerFragment}
        historicalSectorDiversification {
          asOfDate
          benchmarkName
          sectorDiversification {
            percentOfFund
            percentOfIndicativeBenchmark
            percentOfUnderWeightOverWeight
            sector
          }
        }
      }
      fixedIncome {
        ${CommonFragments.disclaimerFragment}
        historicalSectorDiversification {
          asOfDate
          benchmarkName
          sectorDiversification {
            percentOfFund
            percentOfIndicativeBenchmark
            percentOfUnderWeightOverWeight
            sector
          }
        }
      }
    }
  `;
}
